import { defineMessages } from "react-intl";

export const MESSAGES = defineMessages({
  backedBy: {
    id: "funding-application: select-funding-rhs backed by",
    defaultMessage: "We’re backed by:",
  },
});
